<template>
    <div class="machine" v-if="!loading" style=" padding-bottom: 40px">
        <div class="machine-cover" id="overview" ref="overview">
            <img v-if="machine.files.images.length > 0" :src="machine.files.images[0].url">
            <h1>{{ machine.shortName }}</h1>
            <h2 class="title">{{ machine.name }}</h2>
            <div class="description" v-html="machine.shortDescription"></div>
        </div>
        <div class="wrapper">
            
            <div class="flex-between machine-featured-images" v-if="machine.files.images.length > 0">
                <img :src="machine.files.images[0].url">
                <img :src="machine.files.images[1].url" v-if="machine.files.images.length > 1">
            </div>
            <div class="flex-between">
                <div class="main">
                    <template v-if="machine.description">
                    <h3 id="description" ref="description">Descrição Geral de Funcionamento</h3>
                    <div v-html="machine.description"></div>
                    </template>
                    <template v-if="machine.required"> 
                    <h3 id="requirement" ref="requirement">Requisitos do Equipamento</h3>
                    <div v-html="machine.required"></div>
                    </template>
                    <template v-if="machine.advice">
                    <h3 id="recomendaptions" ref="recomendaptions">Recomendações de Aprimoramento</h3>
                    <div v-html="machine.advice"></div>
                    </template>
                    <template v-if="machine.specifications.length > 0">
                    <h3 id="specifications" ref="specification">Especificações Técnicas</h3>
                    <table>
                        <tbody>
                        <tr v-for="(specification, index) in machine.specifications" :key="index">
                            <td>{{ specification.label}}</td>
                            <td>{{ specification | specificationFormat}}</td>
                        </tr>
                        </tbody>
                    </table>
                    </template>
                    <template v-if="videosURL.length">
                    <h3 id="videos"></h3>
                    <iframe width="812" v-for="(video, vindex) in videosURL" :key="vindex" height="456" :src="`https://www.youtube.com/embed/${video}`" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </template>
                    <h3 id="application" ref="application">Aplicações</h3>
                    <div class="prevent">
                        <div class="main-application">
                            <splide :options="options" ref="primary">
                                <splide-slide v-for="(lvl0, i0) in industries[0].industry"  :key="i0">
                                        <figure>
                                        <img :src="lvl0.photos[0].url">
                                        </figure>
                                        <h2>{{ lvl0.title }}</h2>
                                </splide-slide>
                            </splide>
                        </div>
                    </div>


                </div>
                <div class="side-menu" id="side" ref="side">
                    <ul :class="{'fixed': isFixed}" :style="{'width': width + 'px', 'top': (-1 * smoothConfig.offset) + 'px'}">
                        <li><a href="#overview" v-smooth-scroll="smoothConfig">Overview</a></li>
                        <li v-if="machine.description"><a href="#description" v-smooth-scroll="smoothConfig">Descrição geral de funcionamento</a></li>
                        <li v-if="machine.required"><a href="#requirement" v-smooth-scroll="smoothConfig">Requisitos do equipamento</a></li>
                        <li v-if="machine.adivice"><a href="#recomendaptions" v-smooth-scroll="smoothConfig">Recomendações de aprimoramento</a></li>
                        <li v-if="machine.specifications.length > 0"><a href="#specifications" v-smooth-scroll="smoothConfig">Especificações técnicas</a></li>
                        <li v-if="videosURL.length"><a href="#videos" v-smooth-scroll="smoothConfig">Vídeos</a></li>
                                                <li><a href="#application" v-smooth-scroll="smoothConfig">Aplicação</a></li>
                        <li v-if="$user">
                            <button type="button" class="button button-small" v-if="!blockAddItem" @click="addOrder()">Adicionar no orçamento</button>
                            <button type="button" class="button button-small disabled" v-else>Adicionado</button>
                        </li>


                    </ul>
                </div>
            </div>
        </div>
        <!-- <pre>{{ machine | json }}</pre> -->
    </div>
</template>
<script>
export default {
    name: "Machine",
    mounted () {
    },

    created(){
        this.loading = true
        this.isFixed = false;
        this.loadServices()
    },
    watch: {
        'loading'(newValue){
            let self = this
            if(!newValue){
                setTimeout(function(){
                    self.matchHeight()
                },250)
            }
        }
    },
    methods: {
        addOrder(){
            let _this = this
            if(!this.$root.cart){
                this.$root.cart = {
                    docId: null,
                    items: [],
                    uid: this.$user.uid
                }
            } 
            let file = _this.machine &&
            _this.machine.files && 
            _this.machine.files.images && 
            _this.machine.files.images.length && 
            _this.machine.files.images[0] ? _this.machine.files.images[0] : ''
            _this.$root.cart.items.push({quantity: 1, uri: _this.machine.uri, docId: this.machine.docId, name: this.machine.name, file: file, shortName: this.machine.shortName, category: this.machine.category.name})
            this.$root.updated = true
        },
        matchHeight () {
            console.log(this.$refs)
            this.offset = this.$refs.side.offsetTop
            // this.left = this.$ref.side.offsetRight
            this.width = this.$refs.side.clientWidth
            this.onScroll()
            window.addEventListener('scroll', this.onScroll, false)
        },
        loadServices(){
            this.slidesLoading = true
            this.$db.collection("industries").get().then((snap) => {
                let industry = []
                // this.loading = true
                snap.forEach((doc) => {
                    let data = doc.data()
                    data.docId = doc.id
                    industry.push(data)
                    
                    // if(this.$route.params.cat)
                    //     data.industry.forEach((item) => {
                    //         if(this.$route.params.cat == item.title){
                    //             this.application = item
                    //         }
                    //     })
                
                });

                this.industries = industry

                // this.loading = false
            })
            setTimeout(() => {
                this.splide = this.$refs.primary
                                this.slidesLoading = false

            },100)
        },
       
        onScroll(){
            this.scrolled = window.scrollY
            let offset = this.offset + this.smoothConfig.offset 
            this.isFixed = (window.scrollY  > offset)
            let self = this
            let refs = ['overview', 'description', 'requirement', 'recomendaptions', 'specifications']
            refs.forEach(function(item){
                if(window.scrollY > self.$refs[item].offsetTop + self.smoothConfig.offset){
                    self.currentSideRef = item
                }
            })
            
        },
    },
    computed:{
        videosURL(){
            let videos = null
            if(this.machine && this.machine.videos){
                videos = []
                let videosString = this.machine.videos
                var videosArray = videosString.split(/\n/g)
                console.log(videosArray)
                videosArray.forEach((video) => {
                    let url = new URL(video);
                    let code = url.searchParams.get("v");
                    videos.push(code)
                })
            }
            return videos
        },
        blockAddItem(){
            let self = this
            let found = false
            if(self.$root.cart){            
                self.$root.cart.items.forEach(function(item){
                    if(self.$route.params.uri == item.uri){
                        found = true
                    }
                }) 
            }
            return found
        }
    },
    firestore () {
        let self = this
        self.loading = true
        return {
            machinesTg: this.$db.collection("machines").where("uri", "==", this.$route.params.uri)
            .get().then((snap) => {
                let machine = {}
                self.loading = true
                snap.forEach((doc) => {
                    let data = doc.data()
                    data.docId = doc.id
                    machine = data
                    

                });
                self.machine = machine
                self.loading = false
                document.title = `Vacuum Center - ${machine.name}`
                document.querySelector('meta[name="description"]').setAttribute("content", machine.shortDescription);

            })
        }
    },
    data(){
        return{
            industries: [],
            currentSideRef: '',
            left: 0,
            offset: 0,
            width: 0,
            isFixed: false,
            scrolled: 0,
            smoothConfig: {
                duration: 500, offset: -71
            },
            slidesLoading: true,
            machine: {},
            loading: true,
            options: {
                                width       : '100%',

                perPage: 3,
                rewind      : false,
                gap         : 0,
                pagination  : false,
                fixedWidth  : 300,
                fixedHeight : 300,
                focus       : 'center',
                isNavigation: false,
                lazyLoad: 'sequential',
                arrows: false
            },
            splide: null,
        }
    }
}
</script>
<style lang="scss" scoped>
    .flex{
        flex-wrap: nowrap;
    }
    .prevent{
        height: 300px;
        width: 100%;
        overflow: hidden;
        position: relative;
        display: block;
    }
    .main-application{
        top: 0;
        position: absolute;
        overflow-x: auto;
        overflow-y: hidden;
        max-width: calc(1366px - 30%);
    }
    .splide__slide{
        width: auto;
    }
    .cat{
        // display: flex;
        // flex: 0 0 60%;
        max-width: 400px;
    }
        // display: flex;
        // flex-flow: column;
        // align-items: center;
        // justify-content: flex-start;
        
        .splide__slide{
            // border-left: 1px solid rgba(160, 160, 160, 0.3);
            padding: 0;
            transition: .5s all;
            height: 300px;
            cursor:grab;
            > .text{
                display: flex;
                flex-wrap: wrap;
                align-items: flex-end;
                align-content: flex-end;
                padding: 10px;
                > h2{
                    padding: 0;
                    margin: 10px 0 0 0;
                    font-size: 2.2em;
                    color: #32499b;
                }
                > p{
                    padding: 0;
                    margin: 10px 0;
                    opacity: 0;
                    transition: .3s all;
                    cursor: pointer;
                    transform: translateX(20px);
                }
                > *{
                    flex: 0 0 100%;
                }
            }
            
            > * {
                flex: 0 0 50%;
            }
           
            img{
                opacity: .6;
                filter: grayscale(1) brightness(0.75);
                height: 100%;
                transition: 0.5s;
            }
            h2{
                position: absolute;
                color: #fff;
                z-index: 1;
                padding: 10px;
                top: 0;
                left: 0;
                max-width: 300px;
                box-sizing: border-box;
                font-size: 2.5em;
            }
            figure{
                background: #32499b; //#f3f2f0;
                margin: 0;
                padding: 0;
                height: 300px;
                width: 300px;
                // max-width: 200px;
                overflow: hidden;
                justify-content: center;
                
            }

            &:hover{
                background: #f3f2f0;
                .text p{
                    opacity: 1;
                    transform: translateX(0);
                }
                img{

                    opacity: 1;
                    filter: grayscale(0) brightness(0.75);
                }

            }
        }
        
    
    
    .cat.lvl-2{
        display: none;
    }


    @-webkit-keyframes clip-enter{
        0%{
            -webkit-clip-path:polygon(100% 0,100% 0,100% 100%,100% 100%);
            clip-path:polygon(100% 0,100% 0,100% 100%,100% 100%)
        }
        to{
            -webkit-clip-path:polygon(100% 0,0 0,0 100%,100% 100%);
            clip-path:polygon(100% 0,0 0,0 100%,100% 100%)
        }
    }
    @keyframes clip-enter{
        0%{
            -webkit-clip-path:polygon(100% 0,100% 0,100% 100%,100% 100%);
            clip-path:polygon(100% 0,100% 0,100% 100%,100% 100%)
        }
        to{
            -webkit-clip-path:polygon(100% 0,0 0,0 100%,100% 100%);
            clip-path:polygon(100% 0,0 0,0 100%,100% 100%)
        }
    }
    
</style>